/* Refined with Caroline, service page booking fix. Added 2026-09-04.

   PROBLEM (pre-existing, present on v2.22 before any of today's work)
   Service pages rendered TWO identical Book Now buttons:
     1. .rwc-price-booking   from sections/main-product.liquid, above the fold, UNTRACKED
     2. .gg-booking-simple   from the product template, far down the page, TRACKED
   Only the second fired book_now_click, so every click on the prominent top button was
   invisible. The 163 events in 28 days undercounted real booking intent.

   FIX
   Keep the well-placed top button, move the tracking onto it, hide the lower duplicate
   (hidden in rwc-pdp.css so it never flashes). The lower block's explanatory note is
   moved under the surviving button, so no information is lost.

   Event name, category and label are identical to the original so existing GA4
   book_now_click history stays comparable.
*/
(function () {
  function init() {
    var top = document.querySelector('.rwc-price-booking a[href*="glossgenius"]');
    if (!top) return;

    var note = document.querySelector('.gg-booking-simple .gg-booking-note');
    if (note && !document.querySelector('.rwc-price-booking .gg-booking-note')) {
      top.parentNode.appendChild(note);
      note.style.display = 'block';
    }

    if (top.dataset.rwcTracked) return;
    top.dataset.rwcTracked = '1';
    top.addEventListener('click', function () {
      if (typeof gtag === 'function') {
        gtag('event', 'book_now_click', {
          event_category: 'booking',
          event_label: location.pathname.split('/').pop()
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---------------------------------------------------------------------------
   GALLERY ARROWS: centre on the IMAGE, not on the column
   Added 2026-09-04 after Kevin spotted the arrows sitting low on the main image.

   CAUSE, measured on the Monoi page, not guessed:
   .rwc-main-arrow is position:absolute with top:50% + translateY(-50%), and its offset
   parent is .product__column-sticky. That column is 493px tall because it contains the
   main image (372px) AND the thumbnail strip below it. Centring on 493 instead of 372
   pushes the arrows down by roughly half the thumbnail strip, measured at 60px:
   image centre y=398, arrow centre y=458.

   Because the offset is half the DIFFERENCE between column and image height, the error
   changes with every product's image aspect ratio and with the number of thumbnails.
   That is why it looks inconsistent across the site rather than uniformly wrong.

   WHY JAVASCRIPT AND NOT CSS: the arrows are siblings of the media element, not children
   of it, and CSS cannot size one element from a sibling's height. The alternatives were
   re-parenting the arrows in Liquid (a template change across every product template) or
   this. CSS keeps the existing top:50% as the fallback, so if this script fails the
   arrows land exactly where they do today rather than somewhere worse.

   Recalculates on load, on resize, and whenever the media element changes size, which
   covers variant image swaps and lazy-loaded images settling.
--------------------------------------------------------------------------- */
(function () {
  function centreArrows() {
    var cols = document.querySelectorAll('.product__column-sticky');
    for (var c = 0; c < cols.length; c++) {
      var col = cols[c];
      var arrows = col.querySelectorAll('.rwc-main-arrow');
      if (!arrows.length) continue;

      var media =
        col.querySelector('.product__media-item:not([hidden]) .product__media') ||
        col.querySelector('.product__media-item:not([hidden])') ||
        col.querySelector('.product__media-list') ||
        col.querySelector('.product__media');
      if (!media) continue;

      var mr = media.getBoundingClientRect();
      if (!mr.height) continue;

      // `top` on an absolutely positioned element resolves against the offset parent's
      // PADDING box, so the border width has to come out of the rect difference.
      var cr = col.getBoundingClientRect();
      var borderTop = parseFloat(getComputedStyle(col).borderTopWidth) || 0;
      var centre = mr.top - cr.top - borderTop + mr.height / 2;

      for (var i = 0; i < arrows.length; i++) {
        arrows[i].style.top = Math.round(centre) + 'px';
      }
    }
  }

  function watch() {
    centreArrows();
    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(centreArrows);
      var targets = document.querySelectorAll('.product__column-sticky');
      for (var i = 0; i < targets.length; i++) ro.observe(targets[i]);
    }
    window.addEventListener('resize', centreArrows);
    window.addEventListener('load', centreArrows);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
